export const searchModalFilterStorageKey = 'search-modal-filter-options';

export enum SearchType {
  pages = 'pages',
  spaces = 'projects',
  boards = 'boards',
  cards = 'cards',
  epics = 'epics',
  notes = 'notes',
}
